import React from "react";
import ReactDOM from "react-dom/client";
import { Amplify } from "aws-amplify";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { App } from "./App";
import { theme } from "./theme/index";
import awsExports from "./aws-exports.js";
import "@aws-amplify/ui-react/styles.css";
import "./styles/amplify-ultra-minimal.css";
import "./theme/tokens.css";
import {
  ThemeProvider as AmpThemeProvider,
  Theme,
} from "@aws-amplify/ui-react";

// Configurar Amplify con las credenciales de AWS Cognito
Amplify.configure(awsExports);

// Crear root de React 19
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
const Amptheme: Theme = {
  name: "VillApps theme",
  tokens: {
    colors: {
      primary: {
        "10": "#777",
        "80": "#444",
        "90": "#333",
        "100": "#222",
      },
    },
  },
};
// Renderizar aplicación envuelta en tema Material-UI
// El Authenticator está en App.tsx según planificación
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AmpThemeProvider theme={Amptheme}>
        <App />
      </AmpThemeProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
